module.exports = require("fs");